/**
 * Season design intelligence — seasonal colour and mood shifts (trends age, so
 * seasonal fragments carry their own freshness). Keyed by season slug.
 * Additive, pure data.
 */

export const SEASON_KNOWLEDGE = Object.freeze({
  spring: { asOf: '2026', confidence: 0.55, colorPsychology: ['fresh-pastels-and-greens'], visualTrends: ['light-airy-mood'] },
  summer: { asOf: '2026', confidence: 0.55, colorPsychology: ['bright-warm-vivid'], visualTrends: ['sunny-high-energy'] },
  autumn: { asOf: '2026', confidence: 0.55, colorPsychology: ['warm-earthy-tones'], visualTrends: ['cozy-textured'] },
  winter: { asOf: '2026', confidence: 0.55, colorPsychology: ['cool-tones-and-deep-jewel'], visualTrends: ['crisp-elegant'] },
  holiday: { asOf: '2026', confidence: 0.55, colorPsychology: ['festive-warm-and-metallic'], visualTrends: ['celebratory-decorative'] },
});
